import { Typography, useTheme } from "@mui/material";
import { AccountPageLayout } from "components/common/AccountPageLayout";
import { useTenantData } from "contexts/tenant";
import { LoadedContent } from "src/components/common/loading/loadedContent";
import { useTenantTranslation } from "src/hooks/formatters";
import { useSessions } from "../search/SearchSelector/hooks";
import { SearchesTable } from "./SearchesTable";
import { SearchOptionsMenu } from "./SearchOptionsMenu";

export const SearchesPage = () => {
  const { t } = useTenantTranslation();
  const tenantData = useTenantData();
  const theme = useTheme();

  return (
    <AccountPageLayout
      title={t("searches")}
      actionButton={
        <SearchOptionsMenu autoSearchTypes={tenantData.auto_search_types} />
      }
    >
      <Typography sx={{ mb: 5, color: theme.palette.text.secondary }}>
        {t("searchesDescription")}
      </Typography>
      <LoadedContent data={useSessions()} disableFetching enableFullHeight>
        {(sessions) => <SearchesTable sessions={sessions} />}
      </LoadedContent>
    </AccountPageLayout>
  );
};
